// import React from "react";

// const IonsList = () => {
//   return <div>IonsList</div>;
// };

// export default IonsList;

import React from "react";
import { Button } from "../../../../../components";

const IonsList = () => {
  const sizes = ["md", "sm", "xs-sm", "xs"];

  const colors = [
    "primary",
    "success",
    "danger",
    "info",
    "warning",
    "black",
    "white",
  ];
  const variants = ["contained", "outlined", "text"];
  const iconPositions = ["before", "after"];
  const disabled = [false, true];
  const active = [false, true];

  return (
    <div className="py-5 flex-1 flex flex-col gap-20 overflow-auto">
      {colors.map((color, index) => (
        <div key={index} className="flex gap-10">
          {sizes.map((size, index) => (
            <div key={index} className="flex gap-5">
              {variants.map((variant, index) => (
                <div key={index} className="flex flex-col gap-5">
                  {iconPositions.map((iconPosition, index) => (
                    <div key={index} className="flex flex-col gap-5">
                      {disabled.map((disabled, index) => (
                        <div key={index} className="flex flex-col gap-3">
                          <Button
                            type="icon"
                            title={"Button"}
                            size={size}
                            variant={variant}
                            color={color}
                            icon={"add"}
                            iconPosition={iconPosition}
                            disabled={disabled}
                            //active={active}
                          />
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default IonsList;
